import s from "./style.module.css";
export interface Input extends Marko.HTML.Video {}

<let/isVisible=false>
<let/systemPaused=true>
<let/userPaused=undefined as boolean | undefined>
<const/shouldPlay=isVisible && !(userPaused ?? systemPaused)>

<script>
    if (shouldPlay) videoRef().play();
    else videoRef().pause();
</script>

<div class=s.container>
    <video/videoRef
        ...input
        src=input.src
        onLoad() {
            if (!userPaused) videoRef().play();
        }
        muted
        playsinline
        onPause() {
            systemPaused = true;
        }
        onPlay() {
            systemPaused = false;
        }
        loop/>
    <play-button
        aria-label=`${shouldPlay ? "Pause" : "Resume"} video`
        paused=!shouldPlay
        class=s.button
        onClick() {
            userPaused = shouldPlay;
        }/>
</div>

<script>
    userPaused = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) isVisible = true;
        else isVisible = false;
    });
    observer.observe(videoRef());
    $signal.onabort = () => {
        observer.unobserve(videoRef());
        observer.disconnect();
    };
</script>

<return=videoRef>
